var _path, _path2, _path3, _path4, _path5, _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 8.54237C17.8571 10.5762 16.6046 13.0955 15.2381 15.8644C13.4346 19.5186 11.2771 23.3057 9.99996 24C8.68987 23.0504 6.58089 19.5515 4.76187 15.8644C3.46393 13.2336 2.14282 10.5069 2.14282 8.54237C2.14282 3.82455 5.66058 0 9.99996 0C14.3393 0 17.8571 3.82455 17.8571 8.54237Z",
    fill: "#3967BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 8.54237C17.8571 10.5762 16.6046 13.0955 15.2381 15.8644C13.4346 19.5186 11.2771 23.3057 9.99996 24C8.68987 23.0504 6.58089 19.5515 4.76187 15.8644C3.46393 13.2336 2.14282 10.5069 2.14282 8.54237C2.14282 3.82455 5.66058 0 9.99996 0C14.3393 0 17.8571 3.82455 17.8571 8.54237Z",
    fill: "#3967BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2947 9.88235C19.2947 14.9429 15.1412 19.0594 10 19.0594C4.85878 19.0594 0.705286 14.9429 0.705286 9.88235C0.705286 4.82184 4.85878 0.705286 10 0.705286C15.1412 0.705286 19.2947 4.82184 19.2947 9.88235Z",
    fill: "white",
    stroke: "#3967BF",
    strokeWidth: 1.41057
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2947 9.88235C19.2947 14.9429 15.1412 19.0594 10 19.0594C4.85878 19.0594 0.705286 14.9429 0.705286 9.88235C0.705286 4.82184 4.85878 0.705286 10 0.705286C15.1412 0.705286 19.2947 4.82184 19.2947 9.88235Z",
    fill: "white",
    stroke: "#3967BF",
    strokeWidth: 1.41057
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2169 8.15432V11.303C12.2169 11.9482 12.2169 12.2708 12.1039 12.5172C12.0045 12.734 11.8459 12.9102 11.6508 13.0206C11.429 13.1462 11.1387 13.1462 10.5581 13.1462H8.00071C7.42006 13.1462 7.12974 13.1462 6.90796 13.0206C6.71288 12.9102 6.55427 12.734 6.45487 12.5172C6.34187 12.2708 6.34187 11.9482 6.34187 11.303V8.15432M6.37643 6.23438H12.1823C12.3759 6.23438 12.4727 6.23438 12.5466 6.27623C12.6116 6.31304 12.6645 6.37178 12.6976 6.44404C12.7353 6.52618 12.7353 6.6337 12.7353 6.84876V7.53994C12.7353 7.75499 12.7353 7.86252 12.6976 7.94466C12.6645 8.01691 12.6116 8.07565 12.5466 8.11247C12.4727 8.15432 12.3759 8.15432 12.1823 8.15432H6.37643C6.18288 8.15432 6.08611 8.15432 6.01218 8.11247C5.94715 8.07565 5.89429 8.01691 5.86115 7.94466C5.82349 7.86252 5.82349 7.75499 5.82349 7.53994V6.84876C5.82349 6.6337 5.82349 6.52618 5.86115 6.44404C5.89429 6.37178 5.94715 6.31304 6.01218 6.27623C6.08611 6.23438 6.18288 6.23438 6.37643 6.23438ZM8.44997 9.49828H10.1088C10.3024 9.49828 10.3991 9.49828 10.4731 9.54014C10.5381 9.57695 10.591 9.63569 10.6241 9.70795C10.6618 9.79009 10.6618 9.89761 10.6618 10.1127V10.4199C10.6618 10.6349 10.6618 10.7424 10.6241 10.8246C10.591 10.8968 10.5381 10.9556 10.4731 10.9924C10.3991 11.0342 10.3024 11.0342 10.1088 11.0342H8.44997C8.25642 11.0342 8.15965 11.0342 8.08572 10.9924C8.0207 10.9556 7.96783 10.8968 7.9347 10.8246C7.89703 10.7424 7.89703 10.6349 7.89703 10.4199V10.1127C7.89703 9.89761 7.89703 9.79009 7.9347 9.70795C7.96783 9.63569 8.0207 9.57695 8.08572 9.54014C8.15965 9.49828 8.25642 9.49828 8.44997 9.49828Z",
    stroke: "#3967BF",
    strokeWidth: 0.740551,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1229_362)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.4307,
    y: 5,
    width: 3.9496,
    height: 3.9496,
    rx: 1.9748,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3154 6.41064L11.9612 7.7648L11.3477 7.15123",
    stroke: "#3967BF",
    strokeWidth: 0.4937,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.6775,
    y: 5.24685,
    width: 3.4559,
    height: 3.4559,
    rx: 1.72795,
    stroke: "#3967BF",
    strokeWidth: 0.4937
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_362"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.4307,
    y: 5,
    width: 3.9496,
    height: 3.9496,
    rx: 1.9748,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestination);
export default __webpack_public_path__ + "static/media/destination.499e7f764226990dd99bd421ba8210c5.svg";
export { ForwardRef as ReactComponent };